import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateTypeComponent } from './candidate-type.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';
import { CommonService } from './../../services/common.service';

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    FormsModule
  ],
  declarations: [CandidateTypeComponent],
  exports: [CandidateTypeComponent],
  providers: [CommonService]
})
export class CandidateTypeModule { }
